// extracted by mini-css-extract-plugin
export default {"button":"TimeDisplayTitle_button__0hNoo"};